import { DefaultValue, selector, selectorFamily } from 'recoil';
import { valueEmpty } from '@zurich/common/recoil';
import { bankAccountsAtom, localPartyBankAccountAtom } from '../atoms';
export const localPartyBankAccountNameSelector = selector({
    key: 'local/party/bankAccountName',
    get: ({ get }) => {
        const bankAccount = get(localPartyBankAccountAtom);
        return valueEmpty(bankAccount?.name);
    },
    set: ({ get, set }, value) => {
        const bankAccount = get(localPartyBankAccountAtom);
        set(localPartyBankAccountAtom, {
            ...bankAccount,
            name: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyBankAccountHolderSelector = selector({
    key: 'local/party/bankAccountHolder',
    get: ({ get }) => {
        const bankAccount = get(localPartyBankAccountAtom);
        return valueEmpty(bankAccount?.holder);
    },
    set: ({ get, set }, value) => {
        const bankAccount = get(localPartyBankAccountAtom);
        set(localPartyBankAccountAtom, {
            ...bankAccount,
            holder: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyBankAccountIbanSelector = selector({
    key: 'local/party/bankAccountIban',
    get: ({ get }) => {
        const bankAccount = get(localPartyBankAccountAtom);
        return valueEmpty(bankAccount?.iban);
    },
    set: ({ get, set }, value) => {
        const bankAccount = get(localPartyBankAccountAtom);
        set(localPartyBankAccountAtom, {
            ...bankAccount,
            iban: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyBankAccountBicSelector = selector({
    key: 'local/party/bankAccountBic',
    get: ({ get }) => {
        const bankAccount = get(localPartyBankAccountAtom);
        return valueEmpty(bankAccount?.bic);
    },
    set: ({ get, set }, value) => {
        const bankAccount = get(localPartyBankAccountAtom);
        set(localPartyBankAccountAtom, {
            ...bankAccount,
            bic: value instanceof DefaultValue ? null : value,
        });
    },
});
export const localPartyBankAccountSelectorFamily = selectorFamily({
    key: 'local/party/accessLocalPartyBankAccount',
    get: ({ accountNo }) => ({ get }) => {
        const bankAccountsContent = get(bankAccountsAtom);
        const bankAccount = bankAccountsContent.bankAccounts?.find((entry) => entry.accountNo === accountNo);
        if (bankAccount) {
            return bankAccount;
        }
        return get(localPartyBankAccountAtom);
    },
    set: ({ accountNo }) => ({ get, set, reset }) => {
        const bankAccountsContent = get(bankAccountsAtom);
        const bankAccount = bankAccountsContent.bankAccounts?.find((entry) => entry.accountNo === accountNo);
        if (bankAccount) {
            set(localPartyBankAccountAtom, bankAccount);
        }
        else {
            reset(localPartyBankAccountAtom);
        }
    },
});
